import * as types from './actionTypes/settings';
import settingAPI from '../../data/settings-api';
import { startLoading, endLoading } from './loading-actions';
import BaseApi from '../../data/base-api';
import DocumentPortalSettings_ from '../../data/models/DocumentPortalSettings';
import ResponseBase_ from '../../data/models/ResponseBase';

export interface IFinancialInstitutionDisclaimersAndFinePrintActionType {
  type: typeof types.GET_FINANCIAL_INSTITUTION_DISCLAIMERS_AND_FINE_PRINT_SUCCESS |
  typeof types.GET_FINANCIAL_INSTITUTION_DISCLAIMERS_AND_FINE_PRINT_FAIL;
  payload: string;
}

export interface IBrowserTabTitleActionType {
  type: typeof types.GET_BROWSER_TAB_TITLE_SUCCESS | typeof types.GET_BROWSER_TAB_TITLE_FAIL;
  payload: ResponseBase_<string>;
}

export interface IDesignTemplateSettingsActionType {
  type: typeof types.GET_DESIGN_TEMPLATE_SETTINGS_SUCCESS | typeof types.GET_DESIGN_TEMPLATE_SETTINGS_FAIL;
  payload: ResponseBase_<DocumentPortalSettings_>;
}

// eslint-disable-next-line max-len
const getFinancialInstitutionDisclaimersAndFinePrintSuccess = (data: string) => ({ type: types.GET_FINANCIAL_INSTITUTION_DISCLAIMERS_AND_FINE_PRINT_SUCCESS, payload: data, });
// eslint-disable-next-line max-len
const getFinancialInstitutionDisclaimersAndFinePrintFail = (error: string) => ({ type: types.GET_FINANCIAL_INSTITUTION_DISCLAIMERS_AND_FINE_PRINT_FAIL, payload: error, });
const getFinancialInstitutionDisclaimersAndFinePrint = () => async dispatch => {
  const { errorCode, message, result, } = await BaseApi.performPlat(settingAPI.getFinancialInstitutionDisclaimersAndFinePrint());

  return errorCode > 0
    ? dispatch(getFinancialInstitutionDisclaimersAndFinePrintFail(message))
    : dispatch(getFinancialInstitutionDisclaimersAndFinePrintSuccess(result));
};

const getBrowserTabTitleSuccess = (data: string) => ({ type: types.GET_BROWSER_TAB_TITLE_SUCCESS, payload: data, });
const getBrowserTabTitleFail = (error: string) => ({ type: types.GET_BROWSER_TAB_TITLE_FAIL, payload: error, });
const getBrowserTabTitle = () => async dispatch => {
  dispatch(startLoading());

  const response = await BaseApi.performPlat(settingAPI.getBrowserTabTitle());

  dispatch(endLoading());

  return response.errorCode > 0 ? dispatch(getBrowserTabTitleFail(response.message)) : dispatch(getBrowserTabTitleSuccess(response));
};

const getDesignTemplateSettingsSuccess = (data: string) => ({ type: types.GET_DESIGN_TEMPLATE_SETTINGS_SUCCESS, payload: data, });
const getDesignTemplateSettingsFail = (error: string) => ({ type: types.GET_DESIGN_TEMPLATE_SETTINGS_FAIL, payload: error, });
const getDesignTemplateSettings = (institutionId: string) => async dispatch => {
  dispatch(startLoading());
  const response = await BaseApi.performPlat(settingAPI.getDesignTemplateSettings(institutionId));
  dispatch(endLoading());

  // To Do -> Store only result from response, instead of whole response object
  return response.errorCode > 0
    ? dispatch(getDesignTemplateSettingsSuccess(response.message))
    : dispatch(getDesignTemplateSettingsFail(response));
};

export {
  getDesignTemplateSettings,
  getFinancialInstitutionDisclaimersAndFinePrint,
  getBrowserTabTitle
};
